// extracted by mini-css-extract-plugin
export default {"file_input":"uploadFile_file_input__r7abr","upload_button":"uploadFile_upload_button__9HpOn","input_text":"uploadFile_input_text__eZzMB","selected":"uploadFile_selected__wkNXX"};